
<div class="header pb-4">
  <div class="container" style="padding-right: 0;">
    <div class="row space-between display-mobile" style="align-items: center;">
      <div class="logo" routerLink="/">

      <img src="../../../assets/fsetan_logo.png" alt="" style="width: 258px;">
    </div>

      <nav class="navbar display-mobile navbar-expand-lg navbar-light bg-light">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
          <div class="navbar-nav">
            <a routerLink="/expertkltp">Услуги</a>
            <a routerLink="/about">О компании</a>
            <a routerLink="/events">Лента событий</a>
            <a routerLink="/otzyvy">Отзывы</a>
            <a routerLink="/contacts">Контакты</a>
          </div>
        </div>
      </nav>
    </div>
    <div class="row space-between hide-mobile" style="align-items: center;">
      <div class="logo" routerLink="/">

        <img src="../../../assets/fsetan_logo.png" alt="" style="width: 258px;">
      </div>
      <div class="menu-links">
        <a routerLink="/expertkltp">Услуги</a>
        <a routerLink="/about">О компании</a>
        <a routerLink="/events">Лента событий</a>
        <a routerLink="/otzyvy">Отзывы</a>
        <a routerLink="/contacts">Контакты</a>
      </div>
      <div class="header__flat-button">
        <a href="tel:88007758314" style="font-size: 27px; text-decoration: underline;">+7 (495) 135-43-15</a>
        <div class="header__flat-button-help">Рабочий день с 9:00 до 18:00</div>
      </div>
    </div>
  </div>
<!--  <div class="fast-menu">-->
<!--    <div class="container fast-menu-container">-->

<!--      <div class="links" style="margin-left: -25px;">-->
<!--        <div class="dropdown">-->
<!--          <button class="btn fast-links_btn dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->
<!--            Вступить в СРО-->
<!--          </button>-->
<!--          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">-->
<!--            <a class="dropdown-item" routerLink="/sro">Вступление в СРО</a>-->
<!--            <a class="dropdown-item" routerLink="/sro/podgotovka-k-nok">Подготовка к НОК</a>-->
<!--            <a class="dropdown-item" routerLink="/sro/vnesenie-v-nostroy">Внесение в НОСТРОЙ/НОПРИЗ</a>-->
<!--            <a class="dropdown-item" routerLink="/sro/stroysro">СРО в строительстве</a>-->
<!--            <a class="dropdown-item" routerLink="/sro/projsro">СРО в проектировании</a>-->
<!--            <a class="dropdown-item" routerLink="/sro/injsro">СРО в изысканиях</a>-->
<!--            <a class="dropdown-item" routerLink="/sro/dang">СРО особо опасные объекты</a>-->
<!--            <a class="dropdown-item" routerLink="/sro/atomsro">СРО атомные объекты</a>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="dropdown">-->
<!--          <button class="btn fast-links_btn dropdown-toggle" type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->
<!--            Атомная лицензия-->
<!--          </button>-->
<!--          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton2">-->
<!--            <a class="dropdown-item" routerLink="/licensing/atom/opyt_gan/3">Строительство и эксплуатация ОИАЭ</a>-->
<!--            <a class="dropdown-item" routerLink="/licensing/atom/opyt_gan/1">Проектирование и конструирование ОИАЭ</a>-->
<!--            <a class="dropdown-item" routerLink="/licensing/atom/opyt_gan/2">Конструирование и изготовление оборудования для ОИАЭ</a>-->
<!--            <a class="dropdown-item" routerLink="/licensing/atom/opyt_gan/4">Обращение с РВ, ЯМ, РАО</a>-->
<!--          </div>-->
<!--        </div><div class="dropdown">-->
<!--        <button class="btn fast-links_btn dropdown-toggle" type="button" id="dropdownMenuButton3" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->
<!--          Лицензирование-->
<!--        </button>-->
<!--        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton3">-->
<!--          <a class="dropdown-item" routerLink="/licensing/litsenzija-na-provedenie-ekspertizy-promyshlennoj-bezopasnosti">Лицензия на право проведения ЭПБ</a>-->
<!--          <a class="dropdown-item" routerLink="/licensing/litsenzija-rostehnadzora/litsenzija-ekspluatatsiju-vzryvopozharoopasnyh-i-himicheski-opasnyh-obektov">Лицензия на эксплуатацию ОПО</a>-->
<!--          <a class="dropdown-item" routerLink="/licensing/licenziya-obrashenie-vzryvchatyh-materialov">Лицензия на обращение с взрывчатыми веществами</a>-->
<!--          <a class="dropdown-item" routerLink="/licensing/litsenzija-rostehnadzora/markshederia/">Маркшейдерская лицензия</a>-->
<!--          <a class="dropdown-item" routerLink="/licensing/mchs">Лицензия МЧС</a>-->
<!--          <a class="dropdown-item" routerLink="/licensing/rospotrebnadzor">Лицензия на ИИИ</a>-->
<!--          <a class="dropdown-item" routerLink="/licensing/restoration">Лицензия Министерства Культуры</a>-->
<!--          <a class="dropdown-item" routerLink="/licensing/rzd">Уведомление о начале деятельности по погрузке разгрузке на ж/д транспорте (опасные грузы)</a>-->
<!--        </div>-->
<!--      </div><div class="dropdown">-->
<!--        <button class="btn fast-links_btn dropdown-toggle" type="button" id="dropdownMenuButton4" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->
<!--          Все для ОПО-->
<!--        </button>-->
<!--        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton4">-->
<!--          <a class="dropdown-item" routerLink="/expertiza/registration_opo">Регистрация ОПО</a>-->
<!--          <a class="dropdown-item" routerLink="/ord">Постановка на учет оборудования, работающего под избыточным давлением (ОРД)</a>-->
<!--          <a class="dropdown-item" routerLink="/gpm">Постановка на учет и регистрация ГПМ (кранов, подъемников и пр.)</a>-->
<!--          <a class="dropdown-item" routerLink="/exception">Исключение из реестра ОПО</a>-->
<!--          <a class="dropdown-item" routerLink="/licensing/report">Сведения (отчет) о производственном контроле для ОПО</a>-->
<!--          <a class="dropdown-item" routerLink="/expertiza/plas">Разработка ПМЛА, ППК, ПРИ</a>-->
<!--          <a class="dropdown-item" routerLink="/expertiza/plarn">Разработка ПЛАРН</a>-->
<!--          <a class="dropdown-item" routerLink="/pasport-tehnicheskogo-ustroystva">Разработка паспортов технических устройств</a>-->
<!--          <a class="dropdown-item" routerLink="/risk_analysis">Анализ риска аварий на ОПО (на опасных производственных объектах)</a>-->
<!--        </div>-->
<!--      </div><div class="dropdown">-->
<!--        <button class="btn fast-links_btn dropdown-toggle" type="button" id="dropdownMenuButton5" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->
<!--          Аттестация специалистов-->
<!--        </button>-->
<!--        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton5">-->
<!--          <a class="dropdown-item" routerLink="/expertiza/expertpb">Аттестация экспертов ПБ</a>-->
<!--          <a class="dropdown-item" routerLink="/licensing/atom/attgan">Аттестация руководителей и комиссий организации по ФНП</a>-->
<!--          <a class="dropdown-item" routerLink="/expertiza/attpb">Аттестация специалистов в области ПБ</a>-->
<!--          <a class="dropdown-item" routerLink="/attestaciya-specialistov/elektrobezopasnost">Аттестация по электробезопасности</a>-->
<!--          <a class="dropdown-item" routerLink="/attestaciya-specialistov/mchs">Аттестация проектировщиков средств пожарной безопасности</a>-->
<!--          <a class="dropdown-item" routerLink="/education_restavration">Аттестация реставраторов</a>-->
<!--        </div>-->
<!--      </div>-->
<!--      </div>-->
<!--      <div class="search-block">-->
<!--        <input id="search-input" style="border: none!important" type="text" placeholder="Поиск по сайту">-->
<!--        <svg id="search" alt="search" class="social__icon" width="47" height="46" viewBox="0 0 47 46"-->
<!--             fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--          <circle cx="23.367" cy="23" r="23" fill="#005E8A"></circle>-->
<!--          <path fill-rule="evenodd" clip-rule="evenodd"-->
<!--                d="M21.947 28.29a6.71 6.71 0 100-13.42 6.71 6.71 0 000 13.42zm0 2.237a8.947 8.947 0 100-17.894 8.947 8.947 0 000 17.894z"-->
<!--                fill="#fff"></path>-->
<!--          <path fill-rule="evenodd" clip-rule="evenodd"-->
<!--                d="M26.751 26.385a1.131 1.131 0 011.6 0l5.684 5.684a1.131 1.131 0 11-1.6 1.6l-5.684-5.685a1.131 1.131 0 010-1.6z"-->
<!--                fill="#fff"></path>-->
<!--        </svg>-->

<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
</div>
